import { AbstractControl, ValidatorFn, UntypedFormGroup } from '@angular/forms';

export function selectCompanyTypeValidator(ckEstabOwned, ckEstab3rdParty, ck3, ck4, ck5, ck6) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
        if (group.get(ckEstabOwned) != null) {
            if (group.get(ckEstabOwned).value && group.get(ckEstab3rdParty).value) {
                // Establishment(Owned) and Establishment(3rd Party) cannot be selected together.
                return { bothEstbChecked: true };
            }
        }
    };
}
